import React  from 'react'
import { useTextResources } from '../../../language';
import DropDown from '../dropdown';

const AllowExternalUpdatesDropDown = ({...rest}) => {
    const text = useTextResources();
    const options = [
        {
            Name: text("Allow"),
            Value: true
        },
        {
            Name: text("DontAllow"),
            Value: false
        }
    ]

    return <DropDown data={options} textField="Name" valueField="Value"  {...rest}/>
}

export default AllowExternalUpdatesDropDown

